export type GalleryProps = {
  images: Array<{
    src: string
    details: string
  }>
}

export const imagesV4 = [
  {
    src: './Website/Resume/Resume/v4-images/home-1.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v4-images/home-2.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v4-images/home-3.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v4-images/home-4.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v4-images/home-5.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v4-images/bcp-1.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v4-images/bcp-2.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v4-images/checkout-1.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v4-images/checkout-2.png',
    details: '',
  },
]

export const admin = [
  {
    src: './Website/Resume/Resume/admin-images/admin-1.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/admin-2.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/admin-3.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/admin-4.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/admin-5.png',
    details: '',
  },
]

export const imagesV6 = [
  {
    src: './Website/Resume/Resume/v6-images/home-v6-1.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v6-images/home-v6-2.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v6-images/home-v6-3.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v6-images/home-v6-4.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v6-images/bcp-v6-1.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v6-images/checkout-v6-1.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v6-images/checkout-v6-2.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v6-images/checkout-v6-3.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/v6-images/checkout-v6-4.png',
    details: '',
  },
]

export const adminImages = [
  {
    src: './Website/Resume/Resume/admin-images/project-admin-1.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-2.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-3.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-4.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-5.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-6.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-7.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-8.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-9.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-10.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-11.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-12.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-13.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-14.png',
    details: '',
  },
  {
    src: './Website/Resume/Resume/admin-images/project-admin-15.png',
    details: '',
  },
]
